import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-688020da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center",
  style: { height: '100vh', width: '100vw' }
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-34 py-20 rounded-12 font-semibold rise-animation" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "☕"),
  /*#__PURE__*/_createElementVNode("div", { class: "ellipsis-animation" }, "logging you in")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-center",
  style: { height: '100vh', width: '100vw' }
}
const _hoisted_5 = { class: "guard rise-animation self-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "✋", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "You need to login to view this workspace", -1))
const _hoisted_8 = { class: "flex my-12" }
const _hoisted_9 = {
  key: 2,
  class: "flex relative",
  style: { height: '100vh', width: '100vw' }
}
const _hoisted_10 = {
  key: 3,
  class: "flex items-center justify-center",
  style: { height: '100vh', width: '100vw' }
}
const _hoisted_11 = { class: "guard rise-animation" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "🧐", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "We can't seem to find this workspace", -1))
const _hoisted_14 = { class: "flex gap-12 my-12" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" login ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" foyer ")
const _hoisted_17 = {
  key: 4,
  class: "flex items-center justify-center",
  style: { height: '100vh', width: '100vw' }
}
const _hoisted_18 = { class: "guard rise-animation" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "✋", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "You do not have access to this workspace", -1))
const _hoisted_21 = { class: "flex my-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: "AuthGuard",
    class: _normalizeClass({
      'justify-center':
        !_ctx.signedIn ||
        _ctx.signInState == _ctx.SignInState.None ||
        (_ctx.workspace && (!_ctx.loadedWorkspace || _ctx.findFailed || _ctx.accessFailed)),
    })
  }, [
    (!_ctx.signedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_ctx.signInState == _ctx.SignInState.None)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                  class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center cursor-pointer"
                }, " login ")
              ])
            ])
          ]))
        : (_ctx.workspace && !_ctx.loadedWorkspace)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " loading... " + _toDisplayString(_ctx.loadedWorkspace), 1))
          : (_ctx.workspace && _ctx.findFailed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: "/-",
                      class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : (_ctx.workspace && _ctx.accessFailed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                        class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center my-12"
                      }, " login ")
                    ])
                  ])
                ]))
              : (_ctx.signInState == _ctx.SignInState.Success)
                ? _renderSlot(_ctx.$slots, "default", { key: 5 }, undefined, true)
                : _createCommentVNode("", true)
  ], 2))
}